'use client';

interface InfoRow {
  label: string;
  value: string | React.ReactNode;
  mono?: boolean;
}

interface InfoCardProps {
  rows: InfoRow[];
}

export function InfoCard({ rows }: InfoCardProps) {
  return (
    <div className="pub-card" style={{ padding: 0 }}>
      {rows.map((row, i) => (
        <div
          key={i}
          className="flex justify-between items-center"
          style={{
            padding: '12px 16px',
            borderBottom: i < rows.length - 1 ? '1px solid var(--pub-border-subtle)' : 'none',
          }}
        >
          <span
            style={{
              fontFamily: 'var(--font-pub-mono)',
              fontSize: 10,
              color: 'var(--pub-text-muted)',
              letterSpacing: '0.05em',
              textTransform: 'uppercase',
            }}
          >
            {row.label}
          </span>
          <span
            style={{
              fontSize: 13,
              color: 'var(--pub-text-primary)',
              fontWeight: 500,
              ...(row.mono ? { fontFamily: 'var(--font-pub-mono)', fontSize: 12 } : {}),
            }}
          >
            {row.value}
          </span>
        </div>
      ))}
    </div>
  );
}
